import React from 'react'
import Link from 'gatsby-link'

import hd from '../img/hd.svg'
import x from '../img/x.svg'
import leaf from '../img/leaf.svg'
import parsely from '../img/parse.ly.svg'

const Nav = () => (
  <div className="navbar">
    <Link to="/">cover letter</Link> 
    <a href="https://henry.codes/Henry-Desroches_Resume.pdf">resume</a>
    <a href="https://henry.codes/">portfolio</a>
    <Link to="/details">details</Link>
  </div>
)

const Collab = () => (
  <div className="container logos"
    style={{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      paddingTop: '100px'

    }}
  >
    <img src={leaf} alt="Parse.ly"
      style={{
        width: '30%',
        maxWidth: '115px',
        height: 'auto',
      }}
    />
    <img src={x}
      style={{
        height: '17px',
        width: '17px',
      }}
    />
    <img src={hd} alt="Henry Desroches" 
      style={{
        width: '30%',
        maxWidth: '110px',
        height: 'auto',
      }}
    />
  </div>
)
const Hero = () => (
  <div>
    <h1 className="hero">Dear <img src={parsely} /> team</h1>
  </div>
)

export {Collab, Hero, Nav}



// WEBPACK FOOTER //
// ./src/components/letterhead.js